module.exports = __webpack_public_path__ + "img/movasvit.d886ae64.png";